var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33088 7.60876C3.33088 7.23947 3.63425 6.9361 4.0029 6.9361H5.13637C5.50566 6.9361 5.82183 7.23947 5.82183 7.6222V11.8969C5.95367 11.8572 6.11175 11.8175 6.29672 11.7778C6.54696 11.7119 6.73193 11.4879 6.73193 11.2236V5.91976C6.73193 5.55047 7.0353 5.23366 7.41738 5.23366H8.55085C8.92014 5.23366 9.23631 5.53703 9.23631 5.91976V10.8415C9.23631 10.8415 9.51344 10.7224 9.78992 10.604C10.0011 10.5119 10.133 10.3141 10.133 10.076V4.20516C10.133 3.83587 10.4363 3.51906 10.8056 3.51906H11.9391C12.3084 3.51906 12.6117 3.82243 12.6117 4.20516V9.04751C13.5871 8.33518 14.5894 7.47756 15.3805 6.44841C15.6179 6.14504 15.6838 5.74887 15.552 5.37959C14.1017 1.21052 9.54096 -1.00649 5.37509 0.445066C1.20923 1.89662 -1.00522 6.46121 0.444415 10.6309C0.602499 11.1058 0.813704 11.5545 1.06395 11.9897C1.26171 12.3327 1.631 12.5305 2.02653 12.4908C2.23774 12.4774 2.50143 12.4511 2.83039 12.4114C3.12032 12.3852 3.33153 12.1343 3.33153 11.8437L3.33088 7.60876Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30368 14.4694C6.87625 17.0685 11.8728 16.2768 14.4694 12.7016C15.4582 11.3294 15.9984 9.68011 15.9984 7.99175C15.9984 7.80679 15.9849 7.62246 15.9721 7.4375C13.0594 11.8043 7.66731 13.8492 3.30368 14.4694Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.ea04cd9a44213c0bc75d02ec1cdde3b1.svg";
export { ForwardRef as ReactComponent };